// src/lib/intake/intakeDraft.js
//
// Ticket 061 (D-OD2). Before the email code passes, the person's Section 1
// answers live in React state and in a tab-only copy in sessionStorage, so a
// refresh does not lose them. Never sent to the server, cleared once the code
// passes or the person starts over. Nothing goes to localStorage.

const KEY = 'hs_intake_section1_draft'

export function loadDraft() {
  try {
    const raw = window.sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && parsed.answers && parsed.answers.move && parsed.answers.facts ? parsed : null
  } catch {
    return null
  }
}

export function saveDraft({ answers, taxYear, screen }) {
  try { window.sessionStorage.setItem(KEY, JSON.stringify({ answers, taxYear, screen })) } catch { /* private mode: fine */ }
}

export function clearDraft() {
  try { window.sessionStorage.removeItem(KEY) } catch { /* nothing to clear */ }
}
